import { useLazyQuery, useMutation } from '@apollo/client';
import LibraryHeader from '../../components/LibraryHeader/LibraryHeader';
import FileUpload, { categoryType } from '../../components/Popups/FileUpload';
import './SyndicatedVideos.scss';
import { useCallback, useEffect, useRef, useState } from 'react';
import ToasterWithMessage from '../../components/toaster';
import { useLocation, useNavigate } from 'react-router-dom';
import Loader from '../../components/Loader/Loader';
import UploadToaster from '../../components/Popups/UploadProgressBar/UploadProgressPopup';
import { useAppSelector } from '../../redux/app/hooks';
import { STUDENT_ROLE } from '../../utils/constants';
import { debounce } from 'lodash';
import { GET_ALL_SYNDICATED_VIDEOS, INSERT_SYNDICATED_VIDEOS, UPDATE_PLAY_BACK_TIME_FOR_SYNDICATED_VIDEO } from './api/SyndicatedVideosQuery';
import SyndicatedVideosCards from '../../components/SyndicatedVideosCards/SyndicatedVideosCards';
import VideoViewer from '../../components/VideoViewer/VideoViewer';
import { DELETE_IMAGES_PODCASTS, UPDATE_IMAGES_PODCASTS } from '../ImageMaterial/api/ImageMaterialQuery';
import { useDispatch } from 'react-redux';
import { setCurrentVideoData } from '../../redux/slices/dashboardSlice';
import { READ_CLASSROOMUPDATES } from '../TeacherStudentClassroom/api/TeacherStudentClassroomQuery';
import { getScreenDimensions } from '../../utils/helper';
import images from '../../assets/images';
export interface videosData {
    categoryName:string;
    categoryOriginalName: string;
    categoryId:string;
    datas: VideosListForCategory[];
    totalCount: number;
};
export interface VideosListForCategory{
      categoryId: string;
      categoryName: string;
      coverImagePath: string;
      fileId: string;
      filename: string;
      filepath: string;
      filesize:  number;
      isClassroom: boolean;
      playbackTime: string | null;
      feedId? : string;
};

const SyndicatedVideos = () => {
    const dispatch = useDispatch();
    const [url, setUrl] = useState<string>();
    const [filename, setFilename] = useState<string>();
    const [videoFileData, setVideoFileData] = useState<VideosListForCategory | undefined>();
    const [fileData, setFileData] = useState<File | null>();
    const [guideCoverUrl,setGuideCoverUrl] = useState<string>();
    const [videoCategoryData, setVideoCategoryData] = useState<categoryType|null|undefined>();
    const [isUploadOpen, setIsUploadOpen] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);
    const baseUrl = process.env.REACT_APP_FRONTEND_URL;
    const [openVideo, setOpenVideo] = useState(false);
    const [videosData, setVideosData] = useState<videosData[]>();
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadFailed, setUploadFailed] = useState<boolean>(false);
    const [uploadFileName, setUploadFileName] = useState<string>('');
    const [materialAction,setMaterialAction] = useState<string>('');
    const [searchValue, setSearchValue] = useState<string>('');
    const [uploaded, setuploaded] = useState(false);
    const { success, error } = ToasterWithMessage();
    const { state } = useLocation();
    const selectedLibraryId = localStorage.getItem('selectedLId');
    const selectedSubjectId = localStorage.getItem('selectedSId');
    const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
    const role = useAppSelector((state) => state.auth.role);
    const [refetch, SetRefetch] = useState<boolean>(false);
    const videoRef = useRef<HTMLVideoElement | null>(null);
    const clickedVideoRefValue = useAppSelector((state) => state.dashboard.clickedVideoData);
    const backNavigation = role ===STUDENT_ROLE ? '/student-classroom/videos' : '/teacher-classroom/videos';
    const profile = useAppSelector((state) => state?.auth?.adminProfile);
    const currentVideoData = useAppSelector((state) => state?.dashboard?.clickedVideoData);
    const {uploadCloud} = images;


    const navigate = useNavigate();

    const [updatePlayBackTimeForSyndicatedVideo, {loading: uploadLoading}] = useMutation(UPDATE_PLAY_BACK_TIME_FOR_SYNDICATED_VIDEO, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {
            dispatch(setCurrentVideoData({
                videoCurrentTime: 0,
                videoId: ''
            }));
        },
        onError: (err) => {}
    });
  
    const [getAllSyndicatedVideos, { loading }] = useLazyQuery(GET_ALL_SYNDICATED_VIDEOS, {
        fetchPolicy: 'network-only',
        onCompleted: (data) => {
            if (data?.getSyndicatedVideos) {
                setVideosData(data?.getSyndicatedVideos);
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate('/student-classroom/videos', { state: { title: 'Syndicated Videos' } });
                    } else {
                        navigate('/teacher-classroom/videos', { state: { title: 'Syndicated Videos' } });
                    }
                }, 2000);
            }
        }
    });


    const [readFeed] = useMutation(READ_CLASSROOMUPDATES, {
        fetchPolicy: 'network-only',
        onCompleted : (data) =>{
        },
        onError: (err) =>{
          console.log(err.message)
        }
      })

    
      useEffect(()=>{
    if(role === STUDENT_ROLE){
      if(videosData){
        videosData?.forEach((data) => {
            const validFeedId = data.datas.find(item => item.feedId)?.feedId;
            if (validFeedId) {
                readFeed({
                  variables: {
                    fId: validFeedId,
                    uId: profile?.getCurrentUser?.nodes?.[0]?.uId
                  }
                });
              }
        });
      }
    }
      },[profile?.getCurrentUser?.nodes, readFeed, role, videosData])

    const [uploadSyndicatedvideo] = useMutation(INSERT_SYNDICATED_VIDEOS, {
        fetchPolicy: "network-only",
        onCompleted: (data) => {
            if (data?.uploadMylibrarySyndicatedVideos) {
                setFileData(null);
                if (filename) {
                    setUploadFileName(filename);
                }
                setuploaded(true);
                setUploadProgress(100);
                setFilename('');
                setUrl('');
                setGuideCoverUrl('');
                setVideoCategoryData(null);
                getAllSyndicatedVideos({
                    variables: {
                        input:{
                            cId: selectedClassRoomId,
                            lId: selectedLibraryId,
                            sjId: selectedSubjectId,
                            searchInput: `%${searchValue.trim()}%`,
                            category: [
                            {
                                categoryId: "",
                                limit: null,
                                offset: null
                            }
                            ]
                    }
                }
                })
            }
        },
        onError: (err) => {
            if (filename) {
                setUploadFileName(filename);
            }
            setuploaded(true);
            setUploadProgress(0);
            setUploadFailed(true);
        }
    });

    const [updateSyndicatedVideos] = useMutation(UPDATE_IMAGES_PODCASTS, {
        fetchPolicy: "network-only",
        onCompleted: (data) => {
            if (data?.updateImagesPodcastMaterials) {
                if(materialAction === "share"){
                    success("Shared successfully");
                }else if(materialAction === "undoShare"){
                    success("Unshared successfully");
                }
                SetRefetch(!refetch);
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate('/student-classroom/ebooks', { state: { title: 'E-Books' } });
                    } else {
                        navigate('/teacher-classroom/ebooks', { state: { title: 'E-Books' } });
                    }
                }, 2000);
            }
        }
    });

    const [deleteSyndicatedVideos] = useMutation(DELETE_IMAGES_PODCASTS, {
        fetchPolicy: "network-only",
        onCompleted: (data) => {
            if (data?.deleteImagesAndPodcasts) {
                success("Deleted successfully");
                SetRefetch(!refetch);
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate('/student-classroom/ebooks', { state: { title: 'E-Books' } });
                    } else {
                        navigate('/teacher-classroom/ebooks', { state: { title: 'E-Books' } });
                    }
                }, 2000);
            }
        }
    });

    useEffect(() => {
        getAllSyndicatedVideos({
            variables: {
                input:{
                    cId: selectedClassRoomId,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    searchInput: '%%',
                    category: [
                    {
                        categoryId: "",
                        limit: null,
                        offset: null
                    }
                    ]
            }
        }
        });
    }, []);

    useEffect(() => {
        getAllSyndicatedVideos({
            variables: {
              input:{
                cId: selectedClassRoomId,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    searchInput: `%${searchValue.trim()}%`,
                    category: [
                        {
                            categoryId: "",
                            limit: null,
                            offset: null
                        }
                    ]
                }
            }
        })
    }, [refetch]);

    useEffect(() => {
        if (fileData && filename && filename !== '' && url && videoCategoryData && videoCategoryData?.id) {
            uploadSyndicatedvideo({
                variables: {
                    filename: filename?.replace(/\.pdf$/, "")?.trim(),
                    filepath: url,
                    filesize: fileData?.size,
                    isClassRoom: false,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    cId: selectedClassRoomId,
                    ctId: videoCategoryData?.id?.trim(),
                    coverImagePath: guideCoverUrl || null
                }
            });
        }
    }, [fileData, filename, url, videoCategoryData, guideCoverUrl]);

    const handleSearchDebounce = useCallback(
        debounce((value) => {
            setSearchValue(value);
            getAllSyndicatedVideos({
                variables: {
                    input:{
                        cId: selectedClassRoomId,
                        lId: selectedLibraryId,
                        sjId: selectedSubjectId,
                        searchInput: `%${value.trim()}%`,
                        category: [
                        {
                            categoryId: "",
                            limit: null,
                            offset: null
                        }
                        ]
                }
            }
            });
        }, 500),
        [getAllSyndicatedVideos]
    );

    //To open pdf in detailed view
    const handleOpenFile = (data: VideosListForCategory) => {
        setOpenVideo(true);
        setVideoFileData(data);
    }

    //To close pdf detailed view
    const handleCloseVideo = (prevVideoRef: any = null) => {
        if(openVideo && prevVideoRef){
            dispatch(setCurrentVideoData({
                videoCurrentTime: prevVideoRef.currentTime,
                videoId: videoFileData?.fileId ?? ''
            }))
        }
        setOpenVideo(false);
        setVideoFileData(undefined);
    }

    //To done actions in materials
    const handleVideoActions = (data: VideosListForCategory, action: string) => {
        if (action === "share") {
            setMaterialAction("share");
            updateSyndicatedVideos({
                variables:{
                    isClassroom: true,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    cId: selectedClassRoomId,
                    fId: data?.fileId
                }
            });
        } else if (action === "undoShare") {
            setMaterialAction("undoShare");
            updateSyndicatedVideos({
                variables: {
                    isClassroom: false,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    cId: selectedClassRoomId,
                    fId: data?.fileId
                }
            });
        } else if (action === "delete") {
            setMaterialAction('');
            deleteSyndicatedVideos({
                variables: {
                        cId: selectedClassRoomId,
                        fId: data?.fileId,
                        lId: selectedLibraryId,
                        sjId: selectedSubjectId,
                }
            })
        }
    };

    useEffect(() => {
        if(clickedVideoRefValue && clickedVideoRefValue?.videoId){
             // Store the current time when the video is paused
            SetRefetch(!refetch);
            updatePlayBackTimeForSyndicatedVideo({
                variables: {
                    input: {
                      videosPlaybacktime: {
                        fId: clickedVideoRefValue?.videoId,
                        uId: profile.getCurrentUser.nodes[0].uId,
                        playbackTime: clickedVideoRefValue?.videoCurrentTime.toString()
                      }
                    }
                }
            });
        }
    },[clickedVideoRefValue])

    const handleOpenUpload = () => {
        setIsUploadOpen(true);
        setOpen(true);
    };

    return (
        <div className="SyndicatedVideos">
            <LibraryHeader
                image={state?.imageSrc}
                backgroundColor={state?.backGroundColor}
                subject={state?.title}
                subCategory={`Syndicated Videos ${openVideo ? ('/ ' + videoFileData?.categoryName) : ''}`}
                setIsUploadOpen={setIsUploadOpen}
                openPdf={openVideo}
                onClose={handleCloseVideo}
                setOpen={setOpen}
                backNavigation={{ path: backNavigation, state: { title: "Syndicated Videos" } }}
                handleSearchDebounce={handleSearchDebounce}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
                openVideo = {openVideo}
                videoRef={videoRef}
            />
            {
                openVideo ?
                    <VideoViewer 
                        video={videoFileData?.filepath ? baseUrl + videoFileData.filepath : ''} 
                        onClose={handleCloseVideo} 
                        type={"Syndicated Videos"} 
                        videoRef = {videoRef}
                        videoId = {videoFileData?.fileId ? videoFileData?.fileId : ''}
                        videoData = {videoFileData}
                    />
                    :
                    <>
                        {
                            (loading || uploadLoading) ? <Loader bottom='165px' />
                                :
                                (currentVideoData?.videoId === "") && <div className='SyndicatedVideosBody' style={{height: role=== STUDENT_ROLE? '100%' : ''}}>
                                    <SyndicatedVideosCards
                                        subject={state?.title}
                                        subCategory={`Syndicated Videos`}
                                        videosData={videosData}
                                        handleOpenFile={handleOpenFile}
                                        handleVideoActions={handleVideoActions}
                                        reload={()=>SetRefetch(!refetch)}
                                    />
                                </div>
                        }
                    </>
            }
            {/* {isUploadOpen && <FileUpload type='video' name="Syndicated Videos" setVideoCategoryData = {setVideoCategoryData} setCoverImageUrl ={setGuideCoverUrl} setUrl={setUrl} open={open} setOpen={setOpen} folderName="materials" setFilename={setFilename} setFileData={setFileData} />} */}
            {isUploadOpen && <FileUpload type='video' name="Syndicated Videos" setVideoCategoryData = {setVideoCategoryData} setCoverImageUrl ={setGuideCoverUrl} setUrl={setUrl} open={open} setOpen={setOpen} setIsUploadOpen={setIsUploadOpen} folderName="materials" setFilename={setFilename} setFileData={setFileData} setUploadFailed={setUploadFailed} setUploadProgress={setUploadProgress} setuploaded={setuploaded} setUploadFileName={setUploadFileName}/>}
            {uploaded && <UploadToaster uploaded={uploaded} setuploaded={setuploaded} uploadProgress={uploadProgress} setUploadProgress={setUploadProgress} fileName={uploadFileName} setUploadFileName={setUploadFileName} uploadFailed={uploadFailed} setUploadFailed={setUploadFailed} />}

            {(getScreenDimensions()?.isMobileScreen && role !== STUDENT_ROLE) && !openVideo &&
                        <div className='libraryHeaderUploadContainer'> 
                        <div className='libraryHeaderUpload' onClick={handleOpenUpload}>
                         <img src={uploadCloud} alt="upload" className='uploadImage' />
                        </div>
                        </div>}
        </div>
    )
}

export default SyndicatedVideos;
